<template>
  <div>
    <section>
      <div
        style="display: flex; justify-content: space-between; align-items: center;"
      >
        <atividades-tabela :deal-id="dealId" />
      </div>
    </section>
  </div>
</template>

<style>
</style>

<script>
import AtividadesTabela from '@/shared/components/atividades-tabela/AtividadesTabela.vue'

export default {
  name: 'AbaAtividadeOportunidade',
  components: {
    AtividadesTabela,
  },
  props: {
    dealId: {
      type: Number,
      required: true,
    },
  },
}
</script>
